import React, { Component, forwardRef } from 'react'
import styled from 'styled-components'
import { login } from '../../../../utils/Login'
import { isHeaderFixed } from '../../../../../utils/isHeaderFixed'
import { observeMainContentContainerMarginTopChange } from '../utils'

const GAP = 8

class LoginModal extends Component {
  constructor (props) {
    super(props)

    this.cleanupMutationObserver = null
    this.state = {
      isFixed: false,
      mainContentContainerMarginTop: 0
    }

    this.handleScroll = this.handleScroll.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
  }

  componentDidMount () {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()

    this.cleanupMutationObserver = observeMainContentContainerMarginTopChange((newMarginTop) => {
      this.setState({ mainContentContainerMarginTop: newMarginTop })
    })
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
    this.cleanupMutationObserver()
  }

  handleScroll () {
    const fixed = isHeaderFixed(this.props.leaderboardHeight, this.state.mainContentContainerMarginTop)
    if (this.state.isFixed !== fixed) {
      this.setState({ isFixed: fixed })
    }
  }

  updateDimensions (entry) {
    const id = entry.target.id
    const height = entry.contentRect.height

    if (id === this.props.leaderboardId) {
      this.setState({ leaderboardHeight: height })
    }
  }

  render () {
    const { isFixed } = this.state
    const {
      headerHeight,
      innerRef,
      domain,
      ecoIdentity: {
        clientId,
        login: {
          location: loginLocation
        }
      }
    } = this.props
    const offset = headerHeight + GAP

    return (
      <StyledPositioningContainer $isFixed={isFixed} $offset={offset}>
        <StyledContainer innerRef={innerRef}>
          <StyledTitle>Nenechte si nic ujít.</StyledTitle>
          <StyledMessage>
            Když se přihlásíte, upozorníme vás na nové e-maily i důležité zprávy z našich služeb. Pokud jste aktivní diskutér, najdete zde reakce na své příspěvky.
          </StyledMessage>
          <StyledButton onClick={() => login({ loginLocation, clientId, returnURL: domain })}>Přihlásit se</StyledButton>
        </StyledContainer>
      </StyledPositioningContainer>
    )
  }
}

export default forwardRef((props, ref) => <LoginModal {...props} innerRef={ref} />)

const StyledButton = styled.button`
  padding: 8px 0;
  background: ${({ theme }) => theme.headerLogin.loginModal.loginButton.backgroundColor};
  border: 1px solid ${({ theme }) => theme.headerLogin.loginModal.loginButton.borderColor};
  font-size: 11px;
  font-weight: 900;
  line-height: 17px;
  color: ${({ theme }) => theme.headerLogin.loginModal.loginButton.color};
  text-transform: uppercase;
  border-radius: 4px;
  
  &:hover {
    background: ${({ theme }) => theme.headerLogin.loginModal.loginButton.hover.backgroundColor};
    border: ${({ theme }) => `1px solid ${theme.headerLogin.loginModal.loginButton.hover.borderColor}`};
  }
`

const StyledMessage = styled.p`
  color: ${({ theme }) => theme.headerLogin.loginModal.message.color};
  margin: 0;
`

const StyledTitle = styled.div`
  color: ${({ theme }) => theme.headerLogin.loginModal.title.color};
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
`

const StyledPositioningContainer = styled.div`
  position: ${({ $isFixed }) => $isFixed ? 'fixed' : 'static'};
  top: ${({ $offset }) => $offset}px;
  margin-top: ${({ $isFixed }) => $isFixed ? '0px' : '8px'};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 11;
  margin-right: 106px;
  border-radius: 4px;
`

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px; 
  max-width: 293px;
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 6px 12px 0 #00000040;
`
